import { render, staticRenderFns } from "./TicketFromUrl.vue?vue&type=template&id=06d24d72&scoped=true"
import script from "./TicketFromUrl.vue?vue&type=script&lang=ts"
export * from "./TicketFromUrl.vue?vue&type=script&lang=ts"
import style0 from "./TicketFromUrl.vue?vue&type=style&index=0&id=06d24d72&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d24d72",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06d24d72')) {
      api.createRecord('06d24d72', component.options)
    } else {
      api.reload('06d24d72', component.options)
    }
    module.hot.accept("./TicketFromUrl.vue?vue&type=template&id=06d24d72&scoped=true", function () {
      api.rerender('06d24d72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/tickets/TicketFromUrl.vue"
export default component.exports